package org.braunequip.web.util

import org.braunequip.web.util.Routes.backURL

object Constants {
    const val FONT_FAMILY = "Tomorrow"
    const val FONT_FAMILY2 = "Montserrat"

    object SHARED {
        const val ROWS_PER_REQ = 20
    }

    object ASSETS {
        const val TYPE_TRUCK: Short = 1
        const val TYPE_TRAILER: Short = 2
        const val TYPE_OTHER: Short = 4

        const val STATUS_FUNCTIONING: Short = 1
        const val STATUS_OUT_OF_SERVICE: Short = 2
        const val STATUS_UNDER_MAINTENANCE: Short = 4

        //TODO share ideas for other status
//        const val STATUS_IN_TRANSIT: Short = 8
//        const val STATUS_LOADED: Short = 16
//        const val STATUS_UNLOADED: Short = 32
//        const val STATUS_AVAILABLE: Short = 64
//        const val STATUS_ASSIGNED: Short = 128
//        const val STATUS_DECOMMISSIONED: Short = 256
    }
}

object Routes {
    val isDev: Boolean = false
    val backURL: String = if (isDev) "http://localhost:8081" else "/api"

    object Admin {
        const val FRONT_LOGIN_ROUTE = "/braunadmin/login"
        const val FRONT_FORMS_ROUTE = "/braunadmin/"
        const val FRONT_EMPLOYEE_ROUTE = "/braunadmin/employees"
        const val FRONT_ASSET_ROUTE = "/braunadmin/assets"
        const val FRONT_MAINTSCHEDULE_ROUTE = "/braunadmin/maintenance"

        val API_LOGIN_ROUTE = "$backURL/login-auth"
        val API_LOGOUT_ROUTE = "$backURL/logout"
        val API_CHECK_ACCESS = "$backURL/check-auth"
        val PIN_CHECK_ACCESS = "$backURL/portal-pin"

    }

    const val EMPLOYEE_PORTAL = "/employeeportal"
}

object BackendRoutes {
    val CONTACT = "${backURL}/form/contact"
    val TIME_OFF_REQUEST = "${backURL}/form/timerequest"
    val DIESEL_LOG = "${backURL}/form/dieselfuel"
    val EQUIP_REPAIR = "${backURL}/form/equipmentrepair"
    val EMPLOYEE_PINS = "${backURL}/portal-pin"
    val EMPLOYEES = "${backURL}/employees"
    val ASSETS = "${backURL}/assets"
    val MAINT_SCHED = "${backURL}/schedule"
    val MAINT_ITEMS = "${backURL}/maint-items"
}

object Res {
    object Image {
        const val logo = "/braunequiplogo.png"
    }
}

object InputIDs {

    object QuoteForm {
        const val formName = "quoteform"
        const val name = "quoteformname"
        const val email = "quoteformemail"
        const val phone = "quoteformphone"
        const val description = "quoteformdescription"
    }

    object TimeOffForm {
        const val formName = "timeoffrequestform"
        const val firstname = "timeofffirstname"
        const val middlename = "timeoffmiddlename"
        const val lastname = "timeofflastname"
        const val email = "timeoffemail"
        const val phone = "timeoffphone"

        const val startdate = "timeoffstartdate"
        const val enddate = "timeoffenddate"
        const val returndate = "timeoffreturndate"

        const val reason = "timeoffreason"
        const val usepto = "timeoffpto"
        const val message = "timeoffmessage"
    }

    object DieselLogForm {
        const val formName = "dieselfuellogform"

        const val dieselName = "dieseltypename"
        const val dieseltypeDyed = "dieselfuelformdyed"
        const val dieseltypeClear = "dieselfuelformclear"

        const val name = "dieselfuelformname"
        const val date = "dieselfuelformdate"
        const val equipmentid = "dieselfuelformequipmentid"
        const val startingmeter = "dieselfuelformstartingmeter"
        const val endingmeter = "dieselfuelformendingmeter"
        const val totalgallons = "dieselfuelformtotalgallons"
        const val signature = "dieselfuelformsignature"
    }

    object EquipRepairForm {
        const val formName = "equiprepairform"

        const val firstname = "equiprepairfirstname"
        const val lastname = "equiprepairlastname"
        const val date = "equiprepairdatte"

        const val tractorUnit = "equiprepairtractorunit"
        const val tractorNeeds = "equiprepairtractorneeds"
        const val tractorOut = "equiprepairtractorout"
        const val tractorOutYes = "equiprepairformtractoroutyes"
        const val tractorOutNo = "equiprepairformtractoroutno"

        const val trailerUnit = "equiprepairtrailerunit"
        const val trailerNeeds = "equiprepairtrailerneeds"
        const val trailerOut = "equiprepairtrailerout"
        const val trailerOutYes = "equiprepairformtraileroutyes"
        const val trailerOutNo = "equiprepairformtraileroutno"
    }

    object EmployeePin {
        const val portalPin = "portalpininput"

        const val portalNewPin = "portalnewpininput"
        const val portalNewPinDescription = "portalnewpindescription"
    }

    object Employee {
        const val employeeID = "employeeidinput"
        const val employeeFirstName = "employeefirstinput"
        const val employeeLastName = "employeelastinput"
    }

    object Assets {
        const val assetType = "assettypeinput"
        const val assetName = "assetnameinput"
        const val equipmentName = "assetequipmentinput"
        const val assetDescription = "assetdescriptioninput"
        const val assetStatus = "assetstatusinput"
        const val assetyear = "assetyearinput"
        const val assetvin = "assetvininput"
        const val asseteroadid = "asseteroadidinput"
        const val assetmiles = "assetmilesinput"
    }

    object MaintenanceSchedules {
        const val scheduleName = "scheduleName"
        const val scheduleIntervalMiles = "scheduleIntervalMiles"
        const val scheduleIntervalDays = "scheduleIntervalDays"
        const val scheduleStartDate = "scheduleStartDate"
        const val scheduleDescription = "scheduleDescription"

        const val scheduleSelectDropdown = "scheduleSelectDropdown"
    }

    object MaintenanceItems {
        const val completedMiles = "completedMiles"
        const val completedDueDate = "completedDueDate"
        const val MaintItemOnAssetStatus = "MaintItemOnAssetStatus"

    }
}

enum class MaintItemStatus(val status: Short, val label: String) {
    DELETED(0, "Deleted"),
    PENDING(1, "Pending"),
    COMPLETED(2, "Completed"),
    OVERDUE(4, "Overdue");

    companion object {
        fun fromId(id: Short): MaintItemStatus? = entries.find { it.status == id }

        fun asPairList(): List<Pair<Short, String>> {
            return entries.map { it.status to it.label }
        }
    }
}